import axios, { AxiosError, AxiosResponse } from 'axios';
import Rol from '../../../models/Rol';
import { interceptor } from '../../../utils/axios.interceptor';
import { rolEndPoint } from '../../../utils/endPoints';

export const rolInstance = axios.create();
interceptor(rolInstance);

export class RolService {
  /**
   * Used to get the roles list
   * @returns Roles list
   */
  async getRoles(): Promise<any> {
    try {
      const response = await rolInstance.get(rolEndPoint,{ params: { relations: 'tipostareas' } });
      return {
        status: true,
        data: response.data.results,
      };
    } catch (error) {
      return {
        status: false,
        data: {},
      };
    }
  }
  /**
   * Used to create a role
   * @returns Role object
   */
  async postRole(
    role: Rol,
  ): Promise<{ status: boolean; data: AxiosResponse | unknown }> {
    try {
      let result;
      const response = await rolInstance.post(rolEndPoint, role);
      if (response.status === 201) {
        result = { status: true, data: response.data };
      } else {
        result = { status: false, data: [] };
      }
      return result;
    } catch (error) {
      const err = error as AxiosError;
      return {
        status: false,
        data: err.response?.data,
      };
    }
  }
  /**
   * Used to update the rol by id
   * @returns user object deleted
   */
  async updateRole(role: Rol): Promise<{
    status: boolean;
    data: AxiosResponse | unknown;
  }> {
    try {
      const body: Rol = {
        rol: role.rol,
        activo: role.activo,
        permiso: role.permiso,
        tipotareaId: role.tipotareaId,
      };
      const response = await rolInstance.put(`${rolEndPoint}/${role.id}`, body);
      return {
        status: true,
        data: response.data,
      };
    } catch (error) {
      const err = error as AxiosError;
      return {
        status: false,
        data: err.response?.data,
      };
    }
  }
  /**
   * Used to delete the rol by id
   * @returns user object deleted
   */
  async deleteRol(roleId: number): Promise<{
    status: boolean;
    data: AxiosResponse | unknown;
  }> {
    try {
      const response = await rolInstance.delete(`${rolEndPoint}/${roleId}`);
      return {
        status: true,
        data: response.data,
      };
    } catch (error) {
      const err = error as AxiosError;
      return {
        status: false,
        data: err.response?.data,
      };
    }
  }
}
